import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import { customDisclosureStore } from "../../stores/custom-disclosure.store";

const AnalyticsCards = observer(() => {
  const { t } = useTran();
  const { analytics } = customDisclosureStore;

  if (!analytics) return null;

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
      <div className="rounded-radius border border-border bg-card p-4">
        <p className="text-sm text-muted-foreground">{t("Total")}</p>
        <p className="text-2xl font-bold text-foreground">{analytics.total}</p>
      </div>
      <div className="rounded-radius border border-border bg-card p-4">
        <p className="text-sm text-muted-foreground">{t("Active")}</p>
        <p className="text-2xl font-bold text-emerald-600">
          {analytics.active}
        </p>
      </div>
      <div className="rounded-radius border border-border bg-card p-4">
        <p className="text-sm text-muted-foreground">{t("Templates")}</p>
        <p className="text-2xl font-bold text-blue-600">
          {analytics.templates}
        </p>
      </div>
      <div className="rounded-radius border border-border bg-card p-4">
        <p className="text-sm text-muted-foreground">{t("Unused")}</p>
        <p className="text-2xl font-bold text-muted-foreground">
          {analytics.unused}
        </p>
      </div>
    </div>
  );
});

export default AnalyticsCards;
